import { TimeZoneDisplay } from "@models/Sensor/TimeZone.model";

export class ExportDataCriteria {
    filename: string;
    saveAs: ExportSaveAs;
    startDate: string;
    endDate: string;
    uuids: string[];
    sensorReadingTypes: string[];

    interpolateData: boolean;
    interpolateInterval: InterpolationInterval;
    interpolateIntervalValue: number;
    interpolateMethod: InterpolationMethod;

    ignoreOutliers: boolean;
    ignoreOutliersLessThan: number;
    ignoreOutliersGreaterThan: number;

    retrieveRawValues: boolean;
    includeGpsInfo: boolean;
    includeOrigValues: boolean;
    includeCalValues: boolean;

    timeZoneDisplay: TimeZoneDisplay;
    timeZoneOffset: number;
}

export enum InterpolationMethod {
    Linear = "Linear",
    Spline = "Spline"
}

export enum InterpolationInterval {
    I15 = "15 Min",
    I30 = "30 Min",
    I60 = "1 Hr",
    I1440 = "24 Hrs"
}

export enum ExportSaveAs {
    CSV = "CSV",
    JSON = "JSON",
    CSV2 = "CSV2"
}